import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    // width: 'auto',
    // height: 56,
    width: 48,
  },
  path: {
    fill: '#00000',
  },
});

/** @public */
export const AzureLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 96 96"
      xmlns="http://www.w3.org/2000/svg"
      fill="#0078d4"
    >
      <defs>
        <linearGradient
          id="e399c19f-b68f-429d-b176-18c2117ff73c"
          x1="-1032.172"
          x2="-1059.213"
          y1="145.312"
          y2="65.426"
          gradientTransform="matrix(1 0 0 -1 1075 158)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#114a8b" />
          <stop offset="1" stopColor="#0669bc" />
        </linearGradient>
        <linearGradient
          id="ac2a6fc2-ca48-4327-9a3c-d4dcc3256e15"
          x1="-1023.725"
          x2="-1029.98"
          y1="108.083"
          y2="105.968"
          gradientTransform="matrix(1 0 0 -1 1075 158)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopOpacity=".3" />
          <stop offset=".071" stopOpacity=".2" />
          <stop offset=".321" stopOpacity=".1" />
          <stop offset=".623" stopOpacity=".05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="a7fee970-a784-4bb1-af8d-63d18e5f7db9"
          x1="-1027.165"
          x2="-997.482"
          y1="147.642"
          y2="68.561"
          gradientTransform="matrix(1 0 0 -1 1075 158)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3ccbf4" />
          <stop offset="1" stopColor="#2892df" />
        </linearGradient>
      </defs>
      <path
        fill="url(#e399c19f-b68f-429d-b176-18c2117ff73c)"
        d="M33.338 6.544h26.038l-27.03 80.087a4.152 4.152 0 0 1-3.933 2.824H8.149a4.145 4.145 0 0 1-3.928-5.47L29.404 9.368a4.152 4.152 0 0 1 3.934-2.825z"
      />
      <path
        fill="#0078d4"
        d="M71.175 60.261h-41.29a1.911 1.911 0 0 0-1.305 3.309l26.532 24.764a4.171 4.171 0 0 0 2.846 1.121h23.38z"
      />
      <path
        fill="url(#ac2a6fc2-ca48-4327-9a3c-d4dcc3256e15)"
        d="M33.338 6.544a4.118 4.118 0 0 0-3.943 2.879L4.252 83.917a4.14 4.14 0 0 0 3.908 5.538h20.787a4.443 4.443 0 0 0 3.41-2.9l5.014-14.777 17.91 16.705a4.237 4.237 0 0 0 2.666.972H81.24L71.024 60.261l-29.781.007L59.47 6.544z"
      />
      <path
        fill="url(#a7fee970-a784-4bb1-af8d-63d18e5f7db9)"
        d="M66.595 9.364a4.145 4.145 0 0 0-3.928-2.82H33.648a4.146 4.146 0 0 1 3.928 2.82l25.184 74.62a4.146 4.146 0 0 1-3.928 5.472h29.02a4.146 4.146 0 0 0 3.927-5.472z"
      />
    </svg>
  );
};

export const AzureDevOpsLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="#0078d4"
    >
      <path
        fill="url(#azure-devops-color-16__paint0_linear_707_116)"
        d="M15 3.622v8.512L11.5 15l-5.425-1.975v1.958L3.004 10.97l8.951.7V4.005L15 3.622zm-2.984.428L6.994 1v2.001L2.382 4.356 1 6.13v4.029l1.978.873V5.869l9.038-1.818z"
      />
      <defs>
        <linearGradient
          id="azure-devops-color-16__paint0_linear_707_116"
          x1="8"
          x2="8"
          y1="14.956"
          y2="1.026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0078D4" />
          <stop offset=".16" stopColor="#1380DA" />
          <stop offset=".53" stopColor="#3C91E5" />
          <stop offset=".82" stopColor="#559CEC" />
          <stop offset="1" stopColor="#5EA0EF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const OpenShiftLogo = () => {
  const classes = useStyles();

  return (
    <svg
      fill="#000000"
      className={classes.svg}
      viewBox="0 -9.5 256 256"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M74.8392681,106.892926 L33.9714147,121.763314 C34.4958336,128.315376 35.6233978,134.787442 37.211892,141.128721 L76.0290516,126.992265 C74.7846677,120.440203 74.3402448,113.672278 74.8481566,106.891656"
          fill="#DA2430"
        />
        <path
          d="M255.444071,61.7023618 C252.593416,55.8232827 249.297068,50.1410194 245.477572,44.7863591 L204.621146,59.656747 C209.37647,64.5200025 213.363578,69.9864033 216.628181,75.8324681 L255.445341,61.6998222 L255.444071,61.7023618 L255.444071,61.7023618 Z"
          fill="#DA2430"
        />
        <g>
          <path
            d="M182.950275,61.4614413 C177.809695,57.0005792 172.004032,53.1510662 165.54165,50.1365752 L165.53911,50.1365752 C127.598099,32.4485466 82.3304594,48.904889 64.6424308,86.8585985 C63.6454901,89.0001513 62.7625611,91.1647155 61.9886006,93.3462151 C59.7809164,99.7692657 58.4912936,106.33609 57.9978533,112.89241 L57.8539295,112.9456 C57.8501633,112.993635 57.8464406,113.04167 57.8427616,113.089704 L33.2472215,122.039512 L17.4207366,127.888513 C17.418462,127.859314 17.416198,127.830115 17.4139447,127.800914 L16.9799873,127.958822 C15.443554,108.523577 18.7195851,88.4470927 27.5331247,69.5476944 C28.6870135,67.0724846 29.9171924,64.6566205 31.2195686,62.3015921 C60.2738161,8.1856616 126.383568,-14.4341613 182.138317,11.9725342 C193.678037,17.4404824 203.911047,24.6094357 212.694536,33.045511 C218.60401,38.5121214 223.878405,44.5334969 228.475731,50.9860576 L187.616767,65.858985 C187.406509,65.6440827 187.194925,65.4302535 186.982018,65.2175172 L186.868906,65.2593348 C185.610426,63.9523602 184.30416,62.6849771 182.950275,61.4614413 Z"
            fill="#DA2430"
          />
          <path
            d="M19.2613217,193.896477 L19.1968952,193.91993 C10.6957214,181.949719 4.50808591,168.501485 0.938735714,154.347253 L39.7635139,140.206988 L39.7660535,140.209528 C39.7740514,140.251306 39.7820838,140.293077 39.7901508,140.334841 L40.04226,140.241601 L40.0481026,140.257181 C42.0422662,150.817822 46.1933636,160.892394 52.2458245,169.750695 C54.5535333,173.043912 57.1321413,176.165653 59.9682455,179.077478 L59.8140535,179.133611 C59.9116663,179.236598 60.0095901,179.33933 60.1078243,179.441803 L19.6202948,194.412587 C19.500171,194.240851 19.380513,194.068813 19.2613217,193.896477 Z"
            fill="#E82429"
          />
          <path
            d="M173.465486,183.446858 C152.413934,196.46429 125.412387,198.979252 101.351883,187.758961 C92.8405513,183.78963 85.425039,178.421002 79.2335941,172.064486 L38.4622439,186.908208 C38.5659908,187.054117 38.6700845,187.199805 38.7745245,187.345272 L38.754348,187.352733 C49.9644215,203.36935 65.2565512,216.75678 84.0211549,225.651222 C124.490455,244.814382 170.407927,238.152298 203.655476,212.3668 C218.543486,201.215294 230.971995,186.351361 239.368027,168.347841 C248.186646,149.452252 251.443631,129.383387 249.883072,109.963379 L248.747464,110.376585 C248.73211,110.168574 248.716217,109.960636 248.699785,109.752771 L208.210308,124.709923 L208.212255,124.713818 C207.567618,133.637473 205.349363,142.590341 201.405583,151.173176 C195.091199,164.926539 185.242012,175.882135 173.465486,183.446858 Z"
            fill="#DA2430"
          />
          <path
            d="M218.552379,75.1291912 L219.159486,74.9081957 L219.159486,74.9069259 C225.546477,88.0491438 229.444701,102.334163 230.612897,116.962023 L189.840277,131.795587 C189.847816,131.694429 189.855149,131.593274 189.862274,131.492123 L189.091251,131.776983 C190.201352,116.689345 186.816517,101.683505 179.657339,88.6544234 L218.205113,74.4042308 L218.20706,74.4003358 C218.32299,74.6428972 218.438097,74.8858507 218.552379,75.1291912 Z"
            fill="#E82429"
          />
        </g>
        <path
          d="M74.8906707,106.654031 L34.309659,121.650133 C34.8296537,128.260104 35.9494925,134.786331 37.5289522,141.182071 L76.0747786,126.924088 C74.8283493,120.302432 74.3804137,113.486022 74.9062511,106.650136"
          fill="#C22035"
        />
        <path
          d="M254.22692,61.0828228 C251.397136,55.1544934 248.121364,49.4248137 244.329492,44.0242691 L203.758218,59.0203718 C208.479069,63.9262397 212.43843,69.4377942 215.679146,75.334963 L254.221077,61.0789277 L254.22692,61.0828228 L254.22692,61.0828228 Z"
          fill="#C22035"
        />
        <path
          d="M34.3084904,121.652665 L74.7901774,106.824052 L74.624636,114.957003 L35.5685526,129.705767 L34.3026478,121.642928 L34.3084904,121.652665 L34.3084904,121.652665 Z"
          fill="#AC223B"
        />
        <path
          d="M203.766009,58.8974817 L244.8787,44.7894599 L249.151615,51.2377841 L209.205504,65.3594386 L203.771851,58.8935866 L203.766009,58.8974817 L203.766009,58.8974817 Z"
          fill="#AC223B"
        />
        <path
          d="M38.7638909,187.20102 L79.2942665,172.452256 L91.5521198,184.016782 L49.0488803,199.973025 L38.7658385,187.197125 L38.7638909,187.20102 L38.7638909,187.20102 Z"
          fill="#B92135"
        />
        <path
          d="M249.380647,109.861639 L208.215371,124.705833 L205.183043,141.184018 L249.074882,125.54133 L249.38649,109.863587 L249.380647,109.861639 L249.380647,109.861639 Z"
          fill="#B92135"
        />
      </g>
    </svg>
  );
};

export const ConfluenceLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <defs>
        <linearGradient
          id="a"
          x1="28.607"
          y1="-60.825"
          x2="11.085"
          y2="-50.756"
          gradientTransform="matrix(1, 0, 0, -1, 0, -29.66)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#0052cc" />
          <stop offset="1" stopColor="#2684ff" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="621.442"
          y1="1817.567"
          x2="603.915"
          y2="1827.64"
          gradientTransform="matrix(-1, 0, 0, 1, 624.83, -1816.71)"
        />
      </defs>
      <title>file_type_confluence</title>
      <path
        d="M3.015,23.087c-.289.472-.614,1.02-.891,1.456a.892.892,0,0,0,.3,1.212l5.792,3.564a.89.89,0,0,0,1.226-.29l.008-.013c.231-.387.53-.891.855-1.43,2.294-3.787,4.6-3.323,8.763-1.336l5.743,2.731A.892.892,0,0,0,26,28.559l.011-.024L28.766,22.3a.891.891,0,0,0-.445-1.167c-1.212-.57-3.622-1.707-5.792-2.754C14.724,14.586,8.09,14.831,3.015,23.087Z"
        fill="url(#a)"
      />
      <path
        d="M28.985,8.932c.289-.472.614-1.02.891-1.456a.892.892,0,0,0-.3-1.212L23.785,2.7a.89.89,0,0,0-1.236.241.584.584,0,0,0-.033.053c-.232.387-.53.891-.856,1.43-2.294,3.787-4.6,3.323-8.763,1.336L7.172,3.043a.89.89,0,0,0-1.187.421l-.011.024L3.216,9.726a.891.891,0,0,0,.445,1.167c1.212.57,3.622,1.706,5.792,2.753C17.276,17.433,23.91,17.179,28.985,8.932Z"
        fill="url(#a)"
      />
    </svg>
  );
};

export const MonitoringLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="invisible_box" data-name="invisible box">
          <rect width="48" height="48" fill="none" />
        </g>
        <g id="Health_Icons" data-name="Health Icons">
          <g>
            <path d="M43,4H5A2.9,2.9,0,0,0,2,7V35a2.9,2.9,0,0,0,3,3H43a2.9,2.9,0,0,0,3-3V7A2.9,2.9,0,0,0,43,4ZM42,34H6V22.9H8.6a2,2,0,0,0,1.8-1.2l.5-.9,2.9,6.1A1.9,1.9,0,0,0,15.6,28a2.1,2.1,0,0,0,1.8-1.1l4.8-10.2,2.4,5a2.2,2.2,0,0,0,1.8,1.2H30a2,2,0,0,0,0-4H27.7L24,11.1a2,2,0,0,0-3.6,0L15.6,21.3l-2.9-6.1a2.1,2.1,0,0,0-1.8-1.1,1.9,1.9,0,0,0-1.8,1.1L7.3,18.9H6V8H42Z" />
            <path d="M28,28H24a2,2,0,0,0,0,4h4a2,2,0,0,0,0-4Z" />
            <path d="M34,32h4a2,2,0,0,0,0-4H34a2,2,0,0,0,0,4Z" />
            <path d="M37,40H11a2,2,0,0,0,0,4H37a2,2,0,0,0,0-4Z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SonarQubeLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <path d="M15.685.386l-.465.766c3.477 2.112 6.305 5.27 7.966 8.89L24 9.67C22.266 5.887 19.313 2.59 15.685.386zM8.462.91l-.305 1.075c6.89 1.976 12.384 7.64 13.997 14.421l1.085-.258C21.535 8.977 15.735 2.997 8.462.909zM0 2.667v1.342c10.963 0 19.883 8.795 19.883 19.605h1.342c0-11.55-9.522-20.947-21.225-20.947z" />
    </svg>
  );
};

export const SharePointLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <circle cx="15.5" cy="11.5" r="9.5" fill="url(#paint0_linear_87_7767)" />
      <circle cx="24" cy="17" r="8" fill="url(#paint1_linear_87_7767)" />
      <mask
        id="mask0_87_7767"
        maskUnits="userSpaceOnUse"
        x="10"
        y="6"
        width="13"
        height="24"
      >
        <path
          d="M23 23.5C23 27.0899 20.0899 30 16.5 30C12.9101 30 10 27.0899 10 23.5C10 19.9102 10 6 10 6H23C23 6 23 21.1988 23 23.5Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_87_7767)">
        <circle
          cx="16.5"
          cy="23.5"
          r="6.5"
          fill="url(#paint2_linear_87_7767)"
        />
        <path
          d="M7 12C7 10.3431 8.34315 9 10 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H7V12Z"
          fill="#000000"
          fillOpacity="0.3"
        />
      </g>
      <rect
        y="7"
        width="18"
        height="18"
        rx="2"
        fill="url(#paint3_linear_87_7767)"
      />
      <path
        d="M13 18.1229C13 16.5726 11.9602 15.8883 9.79665 15.0922C8.10273 14.4637 7.70021 14.2821 7.70021 13.6816C7.70021 13.1648 8.20335 12.8156 9.0587 12.8156C9.93082 12.8156 10.7526 13.1089 11.6751 13.6117L12.6143 11.9497C11.6247 11.3352 10.4507 11 9.02516 11C6.84486 11 5.28512 12.1173 5.28512 13.8212C5.28512 15.567 6.52621 16.1257 8.60587 16.8659C10.2662 17.4525 10.5849 17.7458 10.5849 18.2626C10.5849 18.8771 9.9979 19.1844 9.07547 19.1844C7.98532 19.1844 7.02935 18.8073 6.07338 18.1927L5 19.7849C6.174 20.595 7.63312 21 9.12579 21C11.3732 21 13 19.9385 13 18.1229Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_87_7767"
          x1="6"
          y1="11.5"
          x2="26.5833"
          y2="11.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#103A3B" />
          <stop offset="1" stopColor="#116B6E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_87_7767"
          x1="18"
          y1="13"
          x2="32"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D9097" />
          <stop offset="1" stopColor="#29BBC2" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_87_7767"
          x1="12"
          y1="21.5"
          x2="23"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#28A6B5" />
          <stop offset="1" stopColor="#31D6EC" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_87_7767"
          x1="0"
          y1="16"
          x2="19.5"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#105557" />
          <stop offset="1" stopColor="#116B6E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ServiceNowLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <path
        d="M859.4 365.7c-8.9 0-17.5 1.3-25.7 3.7-32-148.2-164.1-259.7-321.7-259.7S222.2 221.2 190.3 369.4c-8.2-2.4-16.8-3.7-25.7-3.7-50.4 0-91.4 41-91.4 91.4v109.7c0 50.4 41 91.4 91.4 91.4s91.4-41 91.4-91.4V438.8c0-141.2 114.8-256 256-256s256 114.8 256 256v109.7c0 92.1-48.9 175.4-127.1 221-16.6-23.1-43.7-38.1-74.2-38.1H457c-50.4 0-91.4 41-91.4 91.4 0 50.4 41 91.4 91.4 91.4h109.7c42.9 0 79-29.8 88.8-69.7 81.6-39.6 141.8-109.7 169.2-193.1 10.7 4.4 22.4 6.8 34.7 6.8 50.4 0 91.4-41 91.4-91.4V457.1c0.1-50.4-41-91.4-91.4-91.4zM182.9 566.9c0 10.1-8.2 18.3-18.3 18.3s-18.3-8.2-18.3-18.3V457.1c0-10.1 8.2-18.3 18.3-18.3s18.3 8.2 18.3 18.3v109.8z m383.8 274.3H457c-10.1 0-18.3-8.2-18.3-18.3 0-10.1 8.2-18.3 18.3-18.3h109.7c10.1 0 18.3 8.2 18.3 18.3 0 10.1-8.2 18.3-18.3 18.3z m311-274.3c0 10.1-8.2 18.3-18.3 18.3s-18.3-8.2-18.3-18.3V457.2c0-10.1 8.2-18.3 18.3-18.3s18.3 8.2 18.3 18.3v109.7z"
        fill="#0F1F3C"
      />
      <path d="M512 658.3c80.7 0 146.3-65.6 146.3-146.3h-73.1c0 40.3-32.8 73.1-73.1 73.1S439 552.3 439 512h-73.1c-0.2 80.7 65.4 146.3 146.1 146.3z" />
    </svg>
  );
};

export const GrafanaLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <path
        fill="url(#grafana-color-16__paint0_linear_2372_364)"
        d="M13.985 7.175a4.408 4.408 0 00-.138-.802 5.035 5.035 0 00-1.054-1.998 2.96 2.96 0 00-.366-.393c.198-.787-.245-1.468-.245-1.468-.764-.046-1.237.227-1.42.363-.031-.015-.062-.03-.092-.03-.122-.046-.26-.106-.397-.137-.138-.045-.275-.075-.413-.12-.137-.031-.29-.061-.443-.092-.03 0-.046 0-.076-.015C9.005 1.44 8.058 1 8.058 1 7.004 1.666 6.79 2.604 6.79 2.604s0 .015-.016.06l-.183.046c-.076.03-.168.06-.244.076-.077.03-.168.06-.245.09-.153.076-.32.152-.473.228-.153.09-.306.181-.443.272-.016-.015-.03-.015-.03-.015-1.467-.545-2.766.136-2.766.136-.122 1.544.58 2.528.733 2.71-.03.09-.06.196-.091.287a8.104 8.104 0 00-.245 1.09c0 .06-.015.106-.015.166C1.397 8.386 1 9.748 1 9.748c1.13 1.287 2.46 1.377 2.46 1.377.167.303.366.575.58.848.092.106.183.212.29.318a3.014 3.014 0 00.061 2.149c1.268.045 2.093-.545 2.261-.681.122.045.26.076.382.106.382.106.78.151 1.176.181h.49c.595.848 1.634.954 1.634.954.748-.772.779-1.544.779-1.71v-.015-.03-.03c.153-.107.305-.228.443-.35a5.37 5.37 0 00.779-.892c.015-.03.046-.06.061-.09.84.045 1.436-.515 1.436-.515-.138-.863-.642-1.287-.749-1.378l-.015-.015h-.015s-.015 0-.015-.015c0-.045.015-.106.015-.151 0-.091.015-.182.015-.288V9.4v-.166-.076-.152l-.015-.075c-.015-.091-.03-.197-.061-.288a3.506 3.506 0 00-.428-1.044 3.856 3.856 0 00-.718-.848 3.784 3.784 0 00-.901-.575 3.347 3.347 0 00-.993-.272c-.168-.015-.336-.03-.504-.03H9.37 9.204c-.092.015-.169.015-.26.03-.336.06-.642.181-.932.348-.275.166-.52.363-.718.605a2.579 2.579 0 00-.459.757 2.63 2.63 0 00-.183.817v.393c.015.137.046.273.077.394.076.258.183.485.336.666.137.197.32.348.504.485.183.12.382.212.58.272.199.06.382.076.565.076h.244c.031 0 .047 0 .062-.015.015 0 .046-.015.061-.015.046-.016.076-.016.122-.03l.23-.092a.869.869 0 00.198-.12c.015-.016.03-.03.046-.03a.129.129 0 00.015-.198c-.046-.06-.122-.075-.183-.03-.015.015-.03.015-.046.03-.046.03-.107.046-.168.06l-.183.046c-.03 0-.061.015-.092.015H8.73a1.519 1.519 0 01-.825-.378 1.452 1.452 0 01-.306-.378 1.655 1.655 0 01-.168-.485c-.015-.09-.015-.166-.015-.257v-.106-.03c0-.046.015-.091.015-.136.061-.364.26-.727.55-1 .077-.075.153-.136.23-.181.076-.06.167-.106.259-.151.092-.046.183-.076.29-.106a.993.993 0 01.306-.046h.321c.107.015.229.03.336.046.214.045.427.12.626.242.397.212.733.56.947.969.107.211.183.423.214.65.015.06.015.121.015.167v.363c0 .06-.015.121-.015.182 0 .06-.015.12-.03.181l-.046.182c-.03.121-.077.242-.123.363a3.183 3.183 0 01-.366.666 3.002 3.002 0 01-1.91 1.18c-.122.016-.26.03-.382.046h-.198c-.061 0-.138 0-.199-.015a3.637 3.637 0 01-.81-.151 4.068 4.068 0 01-.748-.303 4.098 4.098 0 01-1.696-1.695 4.398 4.398 0 01-.29-.742c-.076-.257-.107-.514-.137-.772v-.302-.091c0-.136.015-.258.03-.394s.046-.272.061-.393c.03-.137.061-.258.092-.394a5.33 5.33 0 01.275-.741c.214-.47.504-.893.855-1.226.092-.091.184-.167.275-.243.092-.075.184-.136.29-.211a5.39 5.39 0 01.306-.182c.046-.03.107-.045.153-.076a.26.26 0 01.076-.03.26.26 0 01.077-.03c.107-.046.229-.091.336-.121.03-.015.06-.015.091-.03.03-.016.061-.016.092-.03.061-.016.122-.031.168-.046.03-.015.061-.015.092-.015.03 0 .06-.016.091-.016.03 0 .061-.015.092-.015l.046-.015h.046c.03 0 .06-.015.091-.015.03 0 .061-.015.107-.015.03 0 .077-.015.107-.015h.764c.23.015.443.03.657.075.428.076.84.212 1.207.394.366.182.702.393.977.636l.046.045.046.045c.03.03.061.061.107.091l.092.091.091.09c.123.122.23.258.336.394.199.258.367.515.49.772.014.015.014.03.03.046.015.015.015.03.015.045l.046.09.046.092.045.09c.046.122.092.228.123.333.06.167.107.318.137.455.015.045.061.09.122.075a.104.104 0 00.107-.106c.092-.227.092-.393.077-.575z"
      />
      <defs>
        <linearGradient
          id="grafana-color-16__paint0_linear_2372_364"
          x1="7.502"
          x2="7.502"
          y1="18.142"
          y2="5.356"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF200" />
          <stop offset="1" stopColor="#F15A29" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const KibanaLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="-43 0 342 342"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <g>
        <path
          d="M0,306.929431 L0,340.94153 L15.9856864,340.94153 L156.319606,172.717689 C146.588635,166.392997 136.454031,160.712166 125.980814,155.71164 L0,306.929431 Z"
          fill="#009B90"
        />
        <path
          d="M156.32414,172.717689 L15.9221957,341.009554 L255.571444,341.009554 C255.571444,272.441163 216.661603,211.491482 156.32414,172.717689 Z"
          fill="#40BEB0"
        />
        <polygon
          fill="#EF5098"
          points="-5.24025268e-14 0 -1.27897692e-13 307.445368 256 0"
        />
        <path
          d="M0.0681886504,307.339209 L126.243164,155.845133 C86.6932342,137.371934 43.6510777,127.804446 0,128.003058 L0.0681886504,307.339209 Z"
          fill="#353535"
        />
      </g>
    </svg>
  );
};

export const JaegerLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="-113.76 -96.84 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <g transform="matrix(.38094 0 0 .38094 -67.511466 -92.267639)">
        <path
          d="M-3.73 35.388s10.563 4.275 17.354 59.354c0 0-9.8 3.772-3.772 10.312s6.8 18.863 6.8 18.863-35.713 5.28-97.833.754c0 0-24.898-50.803-15.1-68.408l16.348.503s23.64 11.82 22.635-.754c0 0 4.352-.432 5.012-.83s5.747 9.38 19.42-6.936c0 0 21.268-8.125 28.798-12.75zm-81.07 9.31S-91.233 26.2-99.367 30.054s.592 17.674 2.884 20.63c0 .001 7.024-4.58 11.683-5.988z"
          fill="#60d0e4"
        />
        <g fillRule="evenodd">
          <path d="M-30.957 138.898c-.803-1.302-2.67-1.275-4.504-1.542-1.2-.177-3.928-.473-4-1.975-.1-1.64 2.314-2.246 3.95-2.592 3.913-.827 7.814-.68 12.526-.68 2.02 0 4.714.127 4.936 1.48.185 1.136-.775 1.947-1.543 2.468-.682.463-2.06.9-2.097 1.914-.068 1.798 3.24 1.47 2.468 3.948-.285.916-1.874 1.44-3.085 1.8-3.84 1.1-8.353 1.477-12.773 1.852-4 .34-9.118 1.105-13.822.432-1.347-.2-3.124-.706-3.208-1.665-.135-1.537 2.4-2.022 3.764-2.223 3.77-.55 7.307-.308 11.415-.493 2.864-.13 5.74-.1 5.984-2.714zm-40.417.556c2.778-.133 6.68.042 9.44.74.722.183 2.095.48 2.098 1.234.004.806-1.808 1.15-2.838 1.42-5.868 1.52-11.88 2-18.387 2.775-1.183.143-2.412.224-3.703.556-.752.194-2.595.742-2.53 1.666.082 1.14 3.03.83 4.258.926 1.58.122 3.58.314 3.702 1.48.208 1.987-3.717 2.075-5.677 2.22-5.4.405-10.042.203-15.056-.432-.977-.123-2.2-.354-3.208-.74-.9-.347-2.134-.868-2.16-1.728-.04-1.285 1.97-1.77 3.085-2.036 4.14-.982 8.652-1.358 12.958-2.283 2.734-.587 5.427-1.633 7.65-2.53 2.428-.98 4.726-2.248 7.22-2.962 1-.283 1.8-.243 3.146-.308zm51.214 4.32c.644-.065 2.397.007 2.406.863.015 1.252-3.937 1.248-4 .062-.047-.742.872-.85 1.604-.925zm-5.06 1.05c.84-.078 2.244-.03 2.284.864.06 1.354-4 1.296-3.95 0 .028-.585.786-.783 1.665-.864zm-6.046 1.046c.37-.028 1.26-.07 1.913.062.237.048 1.207.405 1.234.74.053.635-1.292.874-1.912.925-1.222.103-3.43-.053-3.518-.802-.086-.737 1.566-.872 2.283-.925zm-8.02.618c.97-.13 3.175-.082 3.208.986.048 1.527-4.9 1.535-4.937.062-.018-.795.977-.947 1.73-1.048zm-9.38.112c.823-.056 1.644-.054 2.53.124.43.085 1.756.392 1.8.985.063 1.135-3.138 1.34-4.7 1.235-.945-.062-2.708-.428-2.715-1.172-.006-.63.952-.843 1.234-.926.673-.195 1.048-.2 1.85-.246zm-57.694 2.47c-.295.9-3.22 1.398-4.32.74.574-1 3.033-1.254 4.32-.74zm.68 1.614c-.753 1.114-3.643 1.518-5.06.803.762-1.104 3.64-1.522 5.06-.803zm1.172 1.48c-.805 1.013-3.65 1.514-5.06.742.563-1.034 3.945-1.55 5.06-.742zm5.183.742c-.523 1.247-4.048 1.798-5.245.802.63-1.312 3.904-1.73 5.245-.802zm4.195.246c.787-.062 2.366-.127 3.208.123 1.56.463.332 1.3-.863 1.604-1.23.323-2.566.476-4.135.37-.738-.05-1.98-.247-2.036-.74-.068-.585 1.127-.873 1.542-.988.9-.252 1.47-.305 2.284-.37zm12.342.678c-.07.783-1.12 1.232-2.037 1.543a13.01 13.01 0 0 1-3.085.616c-.685.043-2.04-.004-2.16-.493-.18-.73 1.466-1.3 1.975-1.48 1.053-.378 2.083-.6 3.023-.678.917-.068 1.945-.04 2.284.493zm51.584-119.087c.07.012.034.062 0 .062-4.13 4.635-7.988 9.6-12.834 13.76-.562.483-1.583 1.47-2.345 1.42-.432-.028-.976-.633-1.418-.803-2.6-.993-5.36 1.026-5.245 3.888-.958.293-1.994.4-3.085.493-1.037.1-2.242.352-3.27.247-.76-.078-1.255-.476-2.283-.37-.473.05-.845.358-1.42.432-.9.114-2.1-.193-3.147-.432-6.56-1.5-12.15-4.92-18.573-6.293.792-.483 1.794-.756 2.715-1.1.158-.298-.32-.778-.185-1.05 15.196 1.584 28.443-2.042 39.8-5.8 3.937-1.303 7.775-2.946 11.3-4.442z" />
          <path
            d="M-42.496 39.185c-11.356 3.758-24.603 7.385-39.8 5.8-.134.27.342.75.185 1.05-.92.354-1.923.628-2.715 1.11 6.422 1.373 12.013 4.784 18.573 6.293 1.038.24 2.258.546 3.147.432.574-.074.946-.383 1.42-.432 1.028-.105 1.522.293 2.283.37 1.03.105 2.233-.158 3.27-.247 1.092-.093 2.127-.2 3.085-.493-.114-2.862 2.635-4.88 5.245-3.888.443.17.987.774 1.418.803.762.05 1.783-.937 2.345-1.42 4.846-4.16 8.706-9.125 12.834-13.76.034 0 .07-.05 0-.062-3.515 1.496-7.353 3.14-11.29 4.442z"
            fill="#638b18"
          />
          <path d="M-36.942 141.613c-4.108.186-7.645-.056-11.415.493-1.375.2-3.9.686-3.764 2.223.084.96 1.86 1.474 3.208 1.665 4.704.674 9.822-.093 13.822-.432 4.42-.375 8.933-.74 12.773-1.852 1.2-.35 2.8-.873 3.085-1.8.773-2.48-2.536-2.15-2.468-3.948.038-1.005 1.416-1.45 2.097-1.914.768-.52 1.728-1.332 1.543-2.468-.222-1.354-2.917-1.48-4.936-1.48-4.7 0-8.613-.148-12.526.68-1.635.346-4.04.953-3.95 2.592.083 1.502 2.8 1.798 4 1.975 1.835.267 3.7.24 4.504 1.542-.243 2.613-3.12 2.584-5.984 2.714zm-37.578-1.85c-2.494.714-4.792 1.982-7.22 2.962-2.224.896-4.917 1.942-7.65 2.53-4.306.925-8.818 1.3-12.958 2.283-1.115.266-3.124.75-3.085 2.036.026.86 1.26 1.38 2.16 1.728 1 .386 2.23.617 3.208.74 5.014.635 9.654.837 15.056.432 1.96-.146 5.885-.233 5.677-2.22-.122-1.166-2.122-1.358-3.702-1.48-1.23-.095-4.176.213-4.258-.926-.065-.924 1.777-1.472 2.53-1.666 1.292-.332 2.52-.413 3.703-.556 6.508-.784 12.52-1.255 18.387-2.775 1.03-.27 2.842-.614 2.838-1.42-.003-.756-1.376-1.052-2.098-1.234-2.76-.698-6.663-.873-9.44-.74-1.346.064-2.156.024-3.146.308zm52.757 4.935c.073 1.187 4.025 1.2 4-.062-.01-.856-1.763-.93-2.406-.863-.732.076-1.65.183-1.604.925zm-5.122 1c-.062 1.296 4 1.354 3.95 0-.04-.896-1.445-.942-2.284-.864-.878.08-1.636.278-1.665.864zm-6.665 1.098c.088.75 2.295.904 3.518.802.62-.05 1.965-.3 1.912-.925-.027-.335-.997-.692-1.234-.74-.652-.133-1.542-.1-1.913-.062-.717.053-2.37.188-2.283.925zm-7.465.74c.035 1.473 4.984 1.465 4.937-.062-.034-1.068-2.24-1.116-3.208-.986-.753.1-1.748.252-1.73 1.048zm-9.503-.678c-.282.083-1.24.296-1.234.926.007.744 1.77 1.1 2.715 1.172 1.552.104 4.752-.1 4.7-1.235-.033-.594-1.36-.9-1.8-.985-.886-.178-1.707-.18-2.53-.124-.8.055-1.175.05-1.85.246zm-60.16 2.962c1.1.658 4.024.17 4.32-.74-1.286-.514-3.745-.26-4.32.74zm-.062 1.666c1.417.715 4.307.312 5.06-.803-1.42-.718-4.298-.3-5.06.803zm1.172 1.42c1.4.77 4.255.27 5.06-.742-1.115-.8-4.497-.292-5.06.742zm4.998.802c1.197.996 4.72.445 5.245-.802-1.34-.927-4.614-.5-5.245.802zm7.157-.188c-.415.115-1.6.403-1.542.988.057.493 1.297.7 2.036.74 1.57.105 2.904-.047 4.135-.37 1.195-.315 2.424-1.142.863-1.604-.842-.25-2.42-.185-3.208-.123-.813.064-1.373.117-2.284.37zm12.343-.182c-.94.068-1.97.3-3.023.678-.5.183-2.156.75-1.975 1.48.12.5 1.475.536 2.16.493a13.06 13.06 0 0 0 3.085-.616c.917-.3 1.967-.76 2.037-1.543-.34-.532-1.368-.56-2.284-.493z" />
        </g>
        <path
          d="M-32.024 24.95C-69.12 41.047-87.73 34.004-87.73 34.004l4.4 8.803c26.533 3.018 53.8-11.255 53.8-11.255l1.364-3.738s-2.26.487-3.56-2.96z"
          fill="#e1caa2"
        />
        <path
          d="M-29.32 14.167l-.472-1.603S-59.69.87-66.48 4.453-82.04 14.262-88.454 23.88l-.094 7.64s18.423 7.64 56.4-8.833c0 0-.503-4.592 2.83-8.52z"
          fill="#638b18"
        />
        <path d="M-27.02 25.048c-.45.392-.874.68-1.32.593-1.348-.265-1.97-2.884-1.388-5.85s2.148-5.155 3.498-4.9c1.297.255 1.92 2.688 1.448 5.514 0 0-1.436 2.635-2.116 4.485z" />
        <path
          d="M-8.635 11.307s-6.79-4.464-14.02 5.47c0 0-.943-5.91-5.785-3.396 0 0 .943-8.488.314-9.683 0 0 1.887.566 2.452 1.823 0 0 4.968-4.84 4.653-11.568 0 0 1.32.188 1.32 1.886 0 0 1.85-4.092 3.663-6.298l.172-.242c7.293-6.35.566 12.576.566 12.576s-.392.94-.793 1.446 3.454-1.285 3.407-2.747.483 2.063 0 2.7c0 0 6.378-5.045 6.566-7.687 0 0 1.006 2.012.754 3.646 0 0 5.658-4.275 5.785-6.288 0 0 .69 10.877-10.06 15.027 0 0 1.76 0 3.96-.44z"
          fill="#e1caa2"
        />
        <path
          d="M-5.05 24.322s22.698-5.03 10.626 3.08-13.833 7.734-13.833 7.734S-5.805 31.5-5.05 24.322zM-8.634 35.45l-20.875 9.117s6.477-5.533 4.276-8.552c0 .001 10.94-1.633 16.6-.565z"
          fill="#638b18"
        />
        <path
          d="M-28 33.88c5.784-16.033 8.692-17.838 8.692-17.838 2.742-2.95 6.193-4.25 8.918-3.002 2.36 1.08 3.626 3.823 3.637 7.137l-.001.21s-.435 8.086-2.698 12.676c0 0-8.425-1.195-17.48 1.195z"
          fill="#60d0e4"
        />
        <path d="M-19.74 26.715s4.526-9.008 7.288-6.926c0 0 .68.815-1.086 6.745 0 0 7.3-8.918-.27-9.145-.001.001-5.07-.18-5.93 9.326zM-90.1 44.397s-5.96-9.016-6.5-7.22.36 4.972.5 5.84-4.554-5.542-1.408-7.88 7.04 4.914 7.4 9.257z" />
        <path
          d="M-97.047 53.515h.235s3.454-2.513 4.475-2.905-1.256 3.768 4.788 3.768-15.7.785-20.645-3.532c0 0-.43-1.867 6.198-4.94 0 0 4 7.148 4.95 7.6z"
          fill="#638b18"
        />
        <path d="M-75.77 55.948c-6.837-3.02-11.954-3.9-11.954-3.9-.05.004-.102.006-.153.006-1.074 0-1.946-.697-1.946-1.556s.872-1.556 1.946-1.556a2.61 2.61 0 0 1 .268.014s5.02.84 12.83 4.103l.85.35c7.262 2.688 10.186 2.76 10.186 2.76.98.083 1.238.083 1.368-.012s.943-.412.943-.412c1.033.027 1.862.743 1.862 1.622 0 .846-1.45 1.767-2.428 1.844 0 0-5.375.424-13.486-3.16zm48.6-18.112c.017-.085.025-.173.025-.264 0-.778-.644-1.4-1.438-1.4a1.47 1.47 0 0 0-.569.114l-5.944 6.487c-2.436 2.758-8.392 9.272-10.886 9.565l-1.408.146c-.118-.234-.754-.8-.754-.8-.4-.355-.94-.505-1.454-.348-.82.25-1.262 1.2-.984 2.098a1.85 1.85 0 0 0 .565.868s4.124 4.177 11.224-3.247l7.746-8.186s3.6-3.932 3.843-4.87z" />
        <path
          d="M-14.754 67.066c0 7.885-6.4 14.283-14.3 14.283S-43.35 74.952-43.35 67.066c0-7.892 6.4-14.3 14.296-14.3a14.3 14.3 0 0 1 14.3 14.29zm-44.4 10.438c0 7.886-6.4 14.283-14.3 14.283S-87.74 85.4-87.74 77.504s6.4-14.3 14.297-14.3a14.3 14.3 0 0 1 14.3 14.3zm11.916 22.896c.377 2.137 1.257 6.664 4.275 6.286s1.887-6.413 1.887-6.413-5.156-.25-5.66 0zm-1.76.594s-2.768 1.18-4.977 2.62c0 0 1.1 5.624 4.77 3.945 0 0 2.415-.532.354-6.187zm-7.028-12.496s-17.6 5.3-8.967 14.2c5.66 5.834 13.494-4.1 17.672-4.004 0 0 .958-.435 2.96-.174s15.062 1.306 16.28-3.918-.348-6.094-1.306-6.703-7.835-4.7-18.108-1.828z"
          fill="#fff"
        />
        <circle cx="-74.702" cy="82.41" r="4.481" />
        <ellipse cx="-30.94" cy="71.722" rx="4.481" ry="4.476" />
        <ellipse
          transform="matrix(.9801 -.1986 .1986 .9801 -18.3085 -8.1092)"
          cx="-49.585"
          cy="87.228"
          rx="7.93"
          ry="4.328"
        />
        <path
          d="M-57.802 91.347s-11.066 5.155-5.9 9.43 7.67-2.64 15.215-3.897 16.222.754 17.982-2.516 2.4-5.9-9.935-7.042c0 0-1.13 5.408-7.67 6.036s-7.668-.504-9.68-2.012z"
          fill="#e1caa2"
        />
        <path
          d="M29.777 115.666s18.272 3.873-8.144 7.747c0 0 6.257-2.582 8.144-7.747z"
          fill="#231f20"
        />
        <path
          d="M17.264 117.453s-.597-9.333-6.158-14.398 4.668-6.653 7.846-5.264 16.386 10.527 4.766 22.245c0 0-4.965 3.575-6.355-2.085z"
          fill="#e1caa2"
        />
        <path d="M-99.488 115.365s-.943 4.715-.188 6.696c0 0-15.94-2.736-.755-6.508z" />
        <path
          d="M-91.85 104.708s-9.787 11.58-4.716 21.03c4.15 7.734 12.543-1.036 12.732-1.32z"
          fill="#e1caa2"
        />
      </g>
    </svg>
  );
};

export const SonarLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <path d="M15.685.386l-.465.766c3.477 2.112 6.305 5.27 7.966 8.89L24 9.67C22.266 5.887 19.313 2.59 15.685.386zM8.462.91l-.305 1.075c6.89 1.976 12.384 7.64 13.997 14.421l1.085-.258C21.535 8.977 15.735 2.997 8.462.909zM0 2.667v1.342c10.963 0 19.883 8.795 19.883 19.605h1.342c0-11.55-9.522-20.947-21.225-20.947z" />
    </svg>
  );
};

export const AdminLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="#00000"
    >
      <path d="M6.834.33a2.25 2.25 0 012.332 0l5.25 3.182A2.25 2.25 0 0115.5 5.436V6A.75.75 0 0114 6v-.564a.75.75 0 00-.361-.642l-5.25-3.181a.75.75 0 00-.778 0l-5.25 3.181A.75.75 0 002 5.436v5.128a.75.75 0 00.361.642l4.028 2.44a.75.75 0 11-.778 1.283l-4.027-2.44A2.25 2.25 0 01.5 10.563V5.436a2.25 2.25 0 011.084-1.924L6.834.33z" />

      <path
        fillRule="evenodd"
        d="M11.749 7.325l.001-.042v-.286a.75.75 0 00-1.5 0v.286l.001.042a3.73 3.73 0 00-1.318.546.76.76 0 00-.03-.03l-.201-.203a.75.75 0 00-1.06 1.06l.201.203.03.028c-.26.394-.45.84-.547 1.319a.878.878 0 00-.04-.001H7a.75.75 0 000 1.5h.286l.038-.001c.097.48.286.926.547 1.32a.71.71 0 00-.028.027l-.202.202a.75.75 0 001.06 1.06l.203-.202a.695.695 0 00.025-.026c.395.261.842.45 1.322.548l-.001.036v.286a.75.75 0 001.5 0v-.286-.036c.48-.097.926-.287 1.32-.548l.026.026.202.203a.75.75 0 001.06-1.061l-.201-.202a.667.667 0 00-.028-.026c.261-.395.45-.842.547-1.321H15a.75.75 0 000-1.5h-.286l-.04.002a3.734 3.734 0 00-.547-1.319l.03-.028.202-.202a.75.75 0 00-1.06-1.061l-.203.202-.029.03a3.73 3.73 0 00-1.318-.545zM11 8.75A2.247 2.247 0 008.75 11 2.247 2.247 0 0011 13.25 2.247 2.247 0 0013.25 11 2.247 2.247 0 0011 8.75z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const TwistLockLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="#6118ff"
    >
      <path d="M59.844 26.366V16.7l-8.378 4.806v9.7zm-8.378 6.72v8.995l7.826-4.513zm-1.04-10.94l-8.4 4.838v21.853l-9.45 5.455v9.676L59.843 48.22v-9.74l-9.416 5.455zM23.054 14.87l7.858-4.546-7.858-4.546zm-.52 11.204l18.93-10.943 9.45 5.455 8.4-4.838L32.016 0l-8.443 4.87 9.45 5.455-18.865 10.878zm-8.865 26.95l7.825-4.513-7.825-4.513zm17.794-9.674l-18.898-10.9v-10.9l-.552-.325L4.156 16.7v31.53L12.6 53.1V42.147l18.865 10.9zm.034 10.94l-8.4-4.87v9.7l8.4 4.87zm-17.86-22.47l8.377 4.838V26.98l-8.377-4.838zm-8.93-16.073l8.377 4.838 8.443-4.87-8.4-4.838zm35.718 21.82l-8.378-4.806-8.4 4.838 8.378 4.838zm-8.962-5.715v-9.708l-8.378 4.838v9.7zm18.4-10.618l-8.4-4.87-8.377 4.838 8.4 4.87zM32.536 31.8l8.4 4.87v-9.677l-8.4-4.87zm0 11.56v9.7l8.4-4.838V38.5z" />
    </svg>
  );
};

export const BlackDuckLogo = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="-6.46 -2.18 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="#010101"
    >
      <path
        d="M28.37 59.637c-7.345-.32-15.808 0-24.207-1.214-1.5-.224-2.746-.734-3.768-1.82C-1.33 54.75-2.67 52.643-3.5 50.28-5.385 45.043-6.63 39.678-6.44 34.1c.064-1.5-.064-3.257 1.5-4.12 1.597-.862 3.066.096 4.44.958.32.192.64.383.926.607 3.896 3.385 8.335 3.768 13.157 2.46 2.363-.64 4.822-.766 7.28-.224.862.192 1.597.064 2.108-.703.5-.798.128-1.565-.35-2.204-.255-.383-.67-.703-1.054-.926-7.888-5.078-8.622-17.916-4.44-24.207C21.535-.912 30.317-1.998 36 3.6c1.022 1 2.012 2.044 2.97 3.13 1.022 1.118 2.172 1.214 3.48.575 1.15-.575 2.204-1.277 3.162-2.14.575-.543 1.182-1.086 1.788-1.565.447-.35.958-.926 1.533-.575.48.287.447 1.022.5 1.597.16 2.62-.958 4.982-1.66 7.4-.447 1.5-.128 2.172 1.405 2.395 1 .128 1.98.383 2.938.67.575.16 1.3.255 1.47 1.054s-.415 1.277-.958 1.693l-4.247 3.353c-2.3 1.884-3.417 4.44-3.96 7.25-.287 1.5.287 2.714 1.597 3.545 1.214.766 2.427 1.5 3.673 2.235 7.4 4.343 8.75 11.752 7.345 18.46-.798 3.928-3.896 6.195-7.888 6.42-6.6.32-13.157.607-20.8.543z"
        fill="#010101"
      />
    </svg>
  );
};
